import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentUserIsGuest } from "@insite/client-framework/Store/Context/ContextSelectors";
import { useSelector } from "react-redux";

const useIsSignedIn = () => {
    return useSelector((state: ApplicationState) => {
        return state.context.session.userName && !getCurrentUserIsGuest(state);
    });
};

export default useIsSignedIn;
